import React from "react"
import Layout from "containers/Layout/Layout"
import RootPageWrapper from "components/RootPageWrapper/RootPageWrapper"
import HomeFirstSection from "components/HomePage/sections/HomeFirstSection/HomeFirstSection"
import HomeSecondSection from "components/HomePage/sections/HomeSecondSection"
import HomeThirdSection from "components/HomePage/sections/HomeThirdSection"
import { graphql, useStaticQuery } from "gatsby"

const Home = () => {
  const { file } = useStaticQuery(graphql`
    query HomePageBanner {
      file(
        sourceInstanceName: { eq: "images" }
        absolutePath: { regex: "/homePage/" }
        name: { regex: "/banner/" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
    }
  `)
  return (
    <Layout>
      <RootPageWrapper
        {...{
          bannerTitle: "Let's collaborate",
          imgBanner: file,
          withBottom: false,
        }}
      >
        <HomeFirstSection />
        <HomeSecondSection />
        <HomeThirdSection />
        {/* <HomeFourthSection />*/}
        {/*Disabled during the COVID-19 pandemic cause there is no meeting taking place*/}
      </RootPageWrapper>
    </Layout>
  )
}

export default Home
